import React from "react";
import styled from "styled-components";

const ResponsiveEmbedContainer = styled.div`
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
`;

export function ResponsiveEmbed({children}: {children: React.ReactNode}) {
    return <ResponsiveEmbedContainer>{children}</ResponsiveEmbedContainer>;
}
